import { PROGRAM_CATEGORY_MAP } from '../../utils/vmt';

export const REQUIRED_EMPTY_COLOR = 'rgba(244, 67, 54, 0.12)';
export const OPTIONAL_EMPTY_COLOR = 'rgba(255, 193, 7, 0.14)';

export const DESIGNATION_OPTIONS = [
  'Product',
  'Package',
  'A la carte',
  'Monthly Fee',
  'One Time Fee',
  'Management Fee',
  'Setup Fee',
  'Other Fee',
  'Sales Tax',
];

export const CATEGORY_OPTIONS = Object.entries(PROGRAM_CATEGORY_MAP).map(([label, value]) => ({
  label,
  value,
}));

export const VENDOR_CODE_OPTIONS = ['5D', '84'];

export const OCCURRENCE_OPTIONS = ['One-Time', 'Weekly', 'Monthly', 'Quarterly', 'Semi-Annual', 'Annual'];

export const IMR_USAGE_OPTIONS = ['Y', 'N'];

export const STATUS_OPTIONS = ['Live', 'Pending Live', 'Pending Cancel', 'Cancelled'];

export const COUNTRY_OPTIONS = [
  { label: 'United States', value: 'US' },
  { label: 'Canada', value: 'CA' },
];

export const FIELD_CONFIGS = [
  { name: 'billingDate', label: 'Billing Date', type: 'date' },
  { name: 'serviceMonth', label: 'Service Month' },
  { name: 'selectionDate', label: 'Selection Date', required: true, type: 'date' },
  { name: 'effectiveDate', label: 'Effective Date', required: true, type: 'date' },
  { name: 'bac', label: 'BAC', required: true },
  { name: 'countryCd', label: 'Country Code', required: true, type: 'select', options: COUNTRY_OPTIONS },
  { name: 'categoryCd', label: 'Category', required: true, type: 'select', options: CATEGORY_OPTIONS },
  { name: 'vendorCd', label: 'Vendor Code', required: true, type: 'select', options: VENDOR_CODE_OPTIONS },
  { name: 'vendorInvoiceNumber', label: 'Vendor Invoice #' },
  { name: 'gmBrandCd', label: 'GM Brand Code', required: true },
  { name: 'productCd', label: 'Product Code', required: true },
  { name: 'productDescription', label: 'Product Description', required: true },
  { name: 'designation', label: 'Designation', required: true, type: 'select', options: DESIGNATION_OPTIONS },
  { name: 'occurrence', label: 'Occurrence', type: 'select', options: OCCURRENCE_OPTIONS },
  { name: 'itemQuantity', label: 'Item Quantity', required: true },
  { name: 'dealerPrice', label: 'Dealer Price' },
  { name: 'filler', label: 'GM Cost (Filler)' },
  { name: 'promoCd', label: 'Promotion Code' },
  { name: 'imrUsage', label: 'IMR Usage', type: 'select', options: IMR_USAGE_OPTIONS },
  { name: 'imrPercentage', label: 'IMR Percentage' },
  { name: 'status', label: 'Status', required: true, type: 'select', options: STATUS_OPTIONS },
  { name: 'lastUpdatedDate', label: 'Last Updated Date', required: true, type: 'date' },
  { name: 'lastUpdatedBy', label: 'Last Updated By', required: true },
  { name: 'referenceId', label: 'Reference ID' },
  { name: 'futureUse1', label: 'Future Use 1' },
  { name: 'futureUse2', label: 'Future Use 2' },
  { name: 'futureUse3', label: 'Future Use 3' },
];
